export enum PolicyCategory {
  EMAIL = "EMAIL",
  PHONE = "PHONE",
  SSN = "SSN",
  IP_ADDRESS = "IP_ADDRESS",
  API_KEY = "API_KEY",
  AWS_KEY = "AWS_KEY",
  PRIVATE_KEY = "PRIVATE_KEY",
  ADDRESS = "ADDRESS",
  GOVERNMENT_ID = "GOVERNMENT_ID",
  TAX_IDENTIFIER = "TAX_IDENTIFIER",
  INSURANCE = "INSURANCE",
  FINANCIAL = "FINANCIAL",
  MEDICAL = "MEDICAL",
  DIGITAL_IDENTITY = "DIGITAL_IDENTITY",
  GEOGRAPHIC = "GEOGRAPHIC",
  EMPLOYEE_ID = "EMPLOYEE_ID",
  VEHICLE = "VEHICLE",
  DEV_SECRET = "DEV_SECRET",
  DEV_IDENTIFIER = "DEV_IDENTIFIER",
  CLOUD_CREDENTIALS = "CLOUD_CREDENTIALS",
  CI_CD_SECRETS = "CI_CD_SECRETS",
  PACKAGE_REGISTRY = "PACKAGE_REGISTRY",
  DATABASE_CREDENTIALS = "DATABASE_CREDENTIALS",
  MONITORING_SECRETS = "MONITORING_SECRETS",
  AUTH_SECRETS = "AUTH_SECRETS",
  MESSAGING_SECRETS = "MESSAGING_SECRETS",
  WEBHOOK_URLS = "WEBHOOK_URLS",
  ENCRYPTION_KEYS = "ENCRYPTION_KEYS",
  CONTAINER_REGISTRY = "CONTAINER_REGISTRY",
  INFRASTRUCTURE_SECRETS = "INFRASTRUCTURE_SECRETS",
  CUSTOM = "CUSTOM",
}

export interface Policy<TName extends string = string> {
  readonly name: TName;
  readonly pattern: RegExp;
  readonly category: PolicyCategory;
  readonly replacement?: string;
}

export const Policies = {
  EMAIL_ADDRESS: "EMAIL_ADDRESS",
  PHONE_NUMBER_US: "PHONE_NUMBER_US",
  PHONE_NUMBER_INTERNATIONAL: "PHONE_NUMBER_INTERNATIONAL",
  PHONE_NUMBER_UK: "PHONE_NUMBER_UK",
  PHONE_NUMBER_CANADIAN: "PHONE_NUMBER_CANADIAN",
  SSN: "SSN",
  CREDIT_CARD: "CREDIT_CARD",
  IPV4_ADDRESS: "IPV4_ADDRESS",
  IPV6_ADDRESS: "IPV6_ADDRESS",
  MAC_ADDRESS: "MAC_ADDRESS",
  UUID: "UUID",
  PASSPORT_NUMBER: "PASSPORT_NUMBER",
  DRIVER_LICENSE: "DRIVER_LICENSE",
  VIN: "VIN",
  ROUTING_NUMBER_US: "ROUTING_NUMBER_US",
  IBAN: "IBAN",
  SWIFT_CODE: "SWIFT_CODE",
  ACCOUNT_NUMBER_US: "ACCOUNT_NUMBER_US",
  ACH_ROUTING_NUMBER: "ACH_ROUTING_NUMBER",
  CREDIT_CARD_CVV: "CREDIT_CARD_CVV",
  BITCOIN_ADDRESS: "BITCOIN_ADDRESS",
  ETHEREUM_ADDRESS: "ETHEREUM_ADDRESS",
  MEDICAL_RECORD_NUMBER: "MEDICAL_RECORD_NUMBER",
  HEALTH_INSURANCE_ID: "HEALTH_INSURANCE_ID",
  URL_WITH_CREDENTIALS: "URL_WITH_CREDENTIALS",
  JWT_TOKEN: "JWT_TOKEN",
  BASE64_URL_PARAM: "BASE64_URL_PARAM",
  API_KEY_GENERIC: "API_KEY_GENERIC",
  BASIC_AUTH_HEADER: "BASIC_AUTH_HEADER",
  BEARER_TOKEN_HEADER: "BEARER_TOKEN_HEADER",
  API_KEY_HEADER: "API_KEY_HEADER",
  SESSION_ID_COOKIE: "SESSION_ID_COOKIE",
  AWS_ACCESS_KEY: "AWS_ACCESS_KEY",
  AWS_SECRET_KEY: "AWS_SECRET_KEY",
  AWS_SESSION_TOKEN: "AWS_SESSION_TOKEN",
  GOOGLE_API_KEY: "GOOGLE_API_KEY",
  OPENAI_API_KEY: "OPENAI_API_KEY",
  ANTHROPIC_API_KEY: "ANTHROPIC_API_KEY",
  GITHUB_TOKEN: "GITHUB_TOKEN",
  GITHUB_FINE_GRAINED_TOKEN: "GITHUB_FINE_GRAINED_TOKEN",
  GITLAB_TOKEN: "GITLAB_TOKEN",
  BITBUCKET_TOKEN: "BITBUCKET_TOKEN",
  AZURE_SUBSCRIPTION_ID: "AZURE_SUBSCRIPTION_ID",
  AZURE_CLIENT_ID: "AZURE_CLIENT_ID",
  AZURE_TENANT_ID: "AZURE_TENANT_ID",
  AWS_ACCOUNT_ID: "AWS_ACCOUNT_ID",
  GCP_API_KEY: "GCP_API_KEY",
  AZURE_STORAGE_CONNECTION_STRING: "AZURE_STORAGE_CONNECTION_STRING",
  DOCKER_HUB_TOKEN: "DOCKER_HUB_TOKEN",
  DOCKER_REGISTRY_TOKEN: "DOCKER_REGISTRY_TOKEN",
  DOCKER_PASSWORD_FLAG: "DOCKER_PASSWORD_FLAG",
  NPM_TOKEN: "NPM_TOKEN",
  PYPI_TOKEN: "PYPI_TOKEN",
  RUBYGEMS_API_KEY: "RUBYGEMS_API_KEY",
  SLACK_WEBHOOK: "SLACK_WEBHOOK",
  SLACK_TOKEN: "SLACK_TOKEN",
  DISCORD_TOKEN: "DISCORD_TOKEN",
  DISCORD_WEBHOOK: "DISCORD_WEBHOOK",
  TWILIO_ACCOUNT_SID: "TWILIO_ACCOUNT_SID",
  TWILIO_AUTH_TOKEN: "TWILIO_AUTH_TOKEN",
  TWILIO_API_KEY: "TWILIO_API_KEY",
  SENDGRID_API_KEY: "SENDGRID_API_KEY",
  STRIPE_KEY: "STRIPE_KEY",
  SQUARE_ACCESS_TOKEN: "SQUARE_ACCESS_TOKEN",
  PAYPAL_CLIENT_ID: "PAYPAL_CLIENT_ID",
  BRAINTREE_ACCESS_TOKEN: "BRAINTREE_ACCESS_TOKEN",
  MAILGUN_API_KEY: "MAILGUN_API_KEY",
  MAILCHIMP_API_KEY: "MAILCHIMP_API_KEY",
  FIREBASE_API_KEY: "FIREBASE_API_KEY",
  FIREBASE_CONFIG: "FIREBASE_CONFIG",
  SUPABASE_API_KEY: "SUPABASE_API_KEY",
  SUPABASE_URL: "SUPABASE_URL",
  NETLIFY_ACCESS_TOKEN: "NETLIFY_ACCESS_TOKEN",
  NETLIFY_SITE_ID: "NETLIFY_SITE_ID",
  HEROKU_API_KEY: "HEROKU_API_KEY",
  DIGITALOCEAN_TOKEN: "DIGITALOCEAN_TOKEN",
  LINODE_API_TOKEN: "LINODE_API_TOKEN",
  VULTR_API_KEY: "VULTR_API_KEY",
  MONGODB_CONNECTION_STRING: "MONGODB_CONNECTION_STRING",
  POSTGRESQL_CONNECTION_STRING: "POSTGRESQL_CONNECTION_STRING",
  MYSQL_CONNECTION_STRING: "MYSQL_CONNECTION_STRING",
  REDIS_CONNECTION_STRING: "REDIS_CONNECTION_STRING",
  ELASTICSEARCH_URL: "ELASTICSEARCH_URL",
  RABBITMQ_CONNECTION_STRING: "RABBITMQ_CONNECTION_STRING",
  KAFKA_CONNECTION_STRING: "KAFKA_CONNECTION_STRING",
  CASSANDRA_CONNECTION_STRING: "CASSANDRA_CONNECTION_STRING",
  DATABASE_CONNECTION_STRING: "DATABASE_CONNECTION_STRING",
  DATABASE_URL: "DATABASE_URL",
  LDAP_CONNECTION_STRING: "LDAP_CONNECTION_STRING",
  JDBC_CONNECTION_STRING: "JDBC_CONNECTION_STRING",
  SMTP_CONNECTION_STRING: "SMTP_CONNECTION_STRING",
  SSH_PRIVATE_KEY: "SSH_PRIVATE_KEY",
  RSA_PRIVATE_KEY: "RSA_PRIVATE_KEY",
  EC_PRIVATE_KEY: "EC_PRIVATE_KEY",
  OPENSSH_PRIVATE_KEY: "OPENSSH_PRIVATE_KEY",
  GENERIC_PRIVATE_KEY: "GENERIC_PRIVATE_KEY",
  PGP_PRIVATE_KEY: "PGP_PRIVATE_KEY",
  BASE64_ENCODED_SECRET: "BASE64_ENCODED_SECRET",
  HEX_ENCODED_SECRET: "HEX_ENCODED_SECRET",
  GENERIC_SECRET: "GENERIC_SECRET",
  GENERIC_TOKEN: "GENERIC_TOKEN",
  GENERIC_CREDENTIAL: "GENERIC_CREDENTIAL",
  GENERIC_PASSWORD: "GENERIC_PASSWORD",
  PASSWORD_ASSIGNMENT: "PASSWORD_ASSIGNMENT",
  CERTIFICATE: "CERTIFICATE",
  ENVIRONMENT_VARIABLE_SECRET: "ENVIRONMENT_VARIABLE_SECRET",
  DOCKER_REGISTRY_AUTH: "DOCKER_REGISTRY_AUTH",
  KUBERNETES_SECRET: "KUBERNETES_SECRET",
  TERRAFORM_VARIABLE: "TERRAFORM_VARIABLE",
  ANSIBLE_VAULT: "ANSIBLE_VAULT",
  ANSIBLE_VAULT_PASSWORD: "ANSIBLE_VAULT_PASSWORD",
  AETNA_MEMBER_ID: "AETNA_MEMBER_ID",
  BCBS_MEMBER_ID: "BCBS_MEMBER_ID",
  UNITEDHEALTH_MEMBER_ID: "UNITEDHEALTH_MEMBER_ID",
  UK_NHS_NUMBER: "UK_NHS_NUMBER",
  CANADIAN_HEALTH_CARD: "CANADIAN_HEALTH_CARD",
  AUSTRALIAN_MEDICARE_NUMBER: "AUSTRALIAN_MEDICARE_NUMBER",
  GERMAN_HEALTH_INSURANCE_NUMBER: "GERMAN_HEALTH_INSURANCE_NUMBER",
  FRENCH_SOCIAL_SECURITY_NUMBER: "FRENCH_SOCIAL_SECURITY_NUMBER",
  EUROPEAN_HEALTH_INSURANCE_CARD: "EUROPEAN_HEALTH_INSURANCE_CARD",
  MEDICARE_NUMBER_US: "MEDICARE_NUMBER_US",
  MEDICAID_NUMBER_US: "MEDICAID_NUMBER_US",
  US_HEALTH_INSURANCE_POLICY: "US_HEALTH_INSURANCE_POLICY",
  US_INSURANCE_GROUP_NUMBER: "US_INSURANCE_GROUP_NUMBER",
  US_INSURANCE_CLAIM_NUMBER: "US_INSURANCE_CLAIM_NUMBER",
  AUTO_INSURANCE_POLICY: "AUTO_INSURANCE_POLICY",
  HOME_INSURANCE_POLICY: "HOME_INSURANCE_POLICY",
  LIFE_INSURANCE_POLICY: "LIFE_INSURANCE_POLICY",
  TRAVEL_INSURANCE_POLICY: "TRAVEL_INSURANCE_POLICY",
  WORKERS_COMPENSATION_CLAIM: "WORKERS_COMPENSATION_CLAIM",
  DISABILITY_INSURANCE_POLICY: "DISABILITY_INSURANCE_POLICY",
  DENTAL_INSURANCE_POLICY: "DENTAL_INSURANCE_POLICY",
  VISION_INSURANCE_POLICY: "VISION_INSURANCE_POLICY",
  US_ZIP_CODE: "US_ZIP_CODE",
  CANADIAN_POSTAL_CODE: "CANADIAN_POSTAL_CODE",
  UK_POSTCODE: "UK_POSTCODE",
  GPS_COORDINATES: "GPS_COORDINATES",
  US_DRIVER_LICENSE: "US_DRIVER_LICENSE",
  US_PASSPORT_NUMBER: "US_PASSPORT_NUMBER",
  NATIONAL_ID: "NATIONAL_ID",
  PASSPORT_MRZ: "PASSPORT_MRZ",
  ITIN: "ITIN",
  US_EIN_WITH_LABEL: "US_EIN_WITH_LABEL",
  US_EIN_PREFIXED: "US_EIN_PREFIXED",
  US_TIN_WITH_LABEL: "US_TIN_WITH_LABEL",
  US_EIN: "US_EIN",
  UK_VAT_NUMBER: "UK_VAT_NUMBER",
  EU_VAT_NUMBER: "EU_VAT_NUMBER",
  CANADIAN_BUSINESS_NUMBER: "CANADIAN_BUSINESS_NUMBER",
  AUSTRALIAN_ABN: "AUSTRALIAN_ABN",
  GERMAN_TAX_NUMBER: "GERMAN_TAX_NUMBER",
  FRENCH_SIRET_NUMBER: "FRENCH_SIRET_NUMBER",
  FRENCH_SIREN_NUMBER: "FRENCH_SIREN_NUMBER",
  EMPLOYEE_ID: "EMPLOYEE_ID",
  US_LICENSE_PLATE: "US_LICENSE_PLATE",
  GOOGLE_CLOUD_PROJECT_ID: "GOOGLE_CLOUD_PROJECT_ID",
  KAFKA_BOOTSTRAP_SERVER: "KAFKA_BOOTSTRAP_SERVER",
  CONTAINER_REGISTRY: "CONTAINER_REGISTRY",
  GIT_SSH_URL: "GIT_SSH_URL",
  API_ENDPOINT_URL: "API_ENDPOINT_URL",
  BUILD_NUMBER: "BUILD_NUMBER",
  VERSION_TAG: "VERSION_TAG",
  COMMIT_HASH: "COMMIT_HASH",
  PR_ISSUE_NUMBER: "PR_ISSUE_NUMBER",
  JIRA_TICKET: "JIRA_TICKET",
  AUTH0_DOMAIN: "AUTH0_DOMAIN",
  VERCEL_DEPLOYMENT_URL: "VERCEL_DEPLOYMENT_URL",
  SERVICE_ACCOUNT_EMAIL: "SERVICE_ACCOUNT_EMAIL",
  WEBHOOK_URL: "WEBHOOK_URL",
  OAUTH_CLIENT_ID: "OAUTH_CLIENT_ID",
  OAUTH_CLIENT_SECRET: "OAUTH_CLIENT_SECRET",
  OAUTH_REFRESH_TOKEN: "OAUTH_REFRESH_TOKEN",
  OAUTH_ACCESS_TOKEN: "OAUTH_ACCESS_TOKEN",
  OKTA_API_TOKEN: "OKTA_API_TOKEN",
  AUTH0_API_TOKEN: "AUTH0_API_TOKEN",
  KEYCLOAK_CLIENT_SECRET: "KEYCLOAK_CLIENT_SECRET",
  SHA_HASH: "SHA_HASH",
  JENKINS_TOKEN: "JENKINS_TOKEN",
  CIRCLECI_TOKEN: "CIRCLECI_TOKEN",
  TRAVIS_CI_TOKEN: "TRAVIS_CI_TOKEN",
  GITLAB_CI_TOKEN: "GITLAB_CI_TOKEN",
  AZURE_DEVOPS_TOKEN: "AZURE_DEVOPS_TOKEN",
  BITBUCKET_TOKEN_ALT: "BITBUCKET_TOKEN_ALT",
  SENTRY_DSN: "SENTRY_DSN",
  NEW_RELIC_LICENSE_KEY: "NEW_RELIC_LICENSE_KEY",
  DATADOG_API_KEY: "DATADOG_API_KEY",
  PAGERDUTY_INTEGRATION_KEY: "PAGERDUTY_INTEGRATION_KEY",
  GRAFANA_API_KEY: "GRAFANA_API_KEY",
  PROMETHEUS_REMOTE_WRITE: "PROMETHEUS_REMOTE_WRITE",
  SPLUNK_HEC_TOKEN: "SPLUNK_HEC_TOKEN",
  SUMO_LOGIC_COLLECTOR: "SUMO_LOGIC_COLLECTOR",
  BUGSNAG_API_KEY: "BUGSNAG_API_KEY",
  ROLLBAR_ACCESS_TOKEN: "ROLLBAR_ACCESS_TOKEN",
  AIRBRAKE_API_KEY: "AIRBRAKE_API_KEY",
  LOGDNA_INGESTION_KEY: "LOGDNA_INGESTION_KEY",
  LOGGLY_TOKEN: "LOGGLY_TOKEN",
  PAPERTRAIL_TOKEN: "PAPERTRAIL_TOKEN",
  TERRAFORM_CLOUD_TOKEN: "TERRAFORM_CLOUD_TOKEN",
  HASHICORP_VAULT_TOKEN: "HASHICORP_VAULT_TOKEN",
  AWS_SECRETS_MANAGER_ARN: "AWS_SECRETS_MANAGER_ARN",
  AZURE_KEY_VAULT_SECRET: "AZURE_KEY_VAULT_SECRET",
  GCP_SECRET_MANAGER: "GCP_SECRET_MANAGER",
  KUBERNETES_CONFIG: "KUBERNETES_CONFIG",
  HELM_REPOSITORY_CREDENTIALS: "HELM_REPOSITORY_CREDENTIALS",
  CONSUL_TOKEN: "CONSUL_TOKEN",
  RANCHER_TOKEN: "RANCHER_TOKEN",
  QUAY_IO_TOKEN: "QUAY_IO_TOKEN",
  JFROG_ARTIFACTORY_TOKEN: "JFROG_ARTIFACTORY_TOKEN",
  NEXUS_REPOSITORY_TOKEN: "NEXUS_REPOSITORY_TOKEN",
  CLOUDFLARE_API_TOKEN: "CLOUDFLARE_API_TOKEN",
  SSH_KEY_FINGERPRINT: "SSH_KEY_FINGERPRINT",
  SONARQUBE_TOKEN: "SONARQUBE_TOKEN",
  LAUNCHDARKLY_SDK_KEY: "LAUNCHDARKLY_SDK_KEY",
  SEGMENT_WRITE_KEY: "SEGMENT_WRITE_KEY",
  MIXPANEL_API_SECRET: "MIXPANEL_API_SECRET",
  ALGOLIA_API_KEY: "ALGOLIA_API_KEY",
  ELASTIC_CLOUD_ID: "ELASTIC_CLOUD_ID",
  RAILWAY_TOKEN: "RAILWAY_TOKEN",
  GCP_SERVICE_ACCOUNT_KEY: "GCP_SERVICE_ACCOUNT_KEY",
  CREDIT_CARD_WITH_SEPARATORS: "CREDIT_CARD_WITH_SEPARATORS",
  PGP_KEY_ID: "PGP_KEY_ID",
  AGE_SECRET_KEY: "AGE_SECRET_KEY",
  AGE_PUBLIC_KEY: "AGE_PUBLIC_KEY",
  AWS_KMS_KEY_ID: "AWS_KMS_KEY_ID",
  GCP_KMS_KEY: "GCP_KMS_KEY",
  AZURE_KEY_IDENTIFIER: "AZURE_KEY_IDENTIFIER",
  MASTER_KEY: "MASTER_KEY",
} as const;

export type PolicyName = (typeof Policies)[keyof typeof Policies];

export type PolicyMap = {
  [K in PolicyName]: Policy<K>;
};

export interface ExcludePattern {
  pattern: RegExp;
  policies?: PolicyName[];
}

export interface RedactumOptions {
  policies?: PolicyName[];
  customPolicies?: Policy[];
  replacement?: string | ((match: string, category: PolicyCategory) => string);
  preserveLength?: boolean;
  excludePatterns?: ExcludePattern[];
}

export interface RedactumResult {
  text: string;
  redactedText: string;
  findings: RedactumFinding[];
  stats: RedactumStats;
}

export interface RedactumFinding {
  category: PolicyCategory;
  policyName: string;
  value: string;
  match: string;
  start: number;
  end: number;
  replacement: string;
}

export interface RedactumStats {
  totalFindings: number;
  findingsByCategory: Partial<Record<PolicyCategory, number>>;
  processingTimeMs: number;
}

export interface RedactumConfig {
  defaultOptions: RedactumOptions;
  enabledCategories: PolicyCategory[];
  customPolicies: Policy[];
}
